// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3988":"843181f7","5635":"432279f9","6163":"8812d6fd","7699":"f2d26c81"}[chunkId] + ".chunk.css";
};